// extracted by mini-css-extract-plugin
export var checkbox = "_2v-0";
export var circle = "_2v-3";
export var horizontalContainer = "_2v-7";
export var sm = "_2v-5";
export var switch0 = "_2v-2";
export var switchDisabled = "_2v-8";
export var switchEnabled = "_2v-1";
export var textSwitchContainer = "_2v-9";
export var textSwitchOption = "_2v-a";
export var textSwitchOptionSelected = "_2v-b";
export var verticalContainer = "_2v-6";
export var xs = "_2v-4";